module.exports = __webpack_public_path__ + "static/media/b23@2x.a1a6eef6.png";